import React from 'react';
import Infinite from 'react-infinite';
import {useSelector, useDispatch} from 'react-redux';

import {countryTextMap, smartEngageBannerSlot, smartEngageBannerCount, srpIndexForFetchMore} from '../../../config/app-config';

import {useNavigateForSearchWidget} from '../../../hooks/useNavigateForSearchWidget';

import {countrySelectorFn, roomStringSelectorFn} from '../../common/redux/selectors';
import {srpSelector} from '../redux/selectors';

import {IHotelData, IHotelDataType, ISrpStoreState} from '../redux/types';

import HotelListPlaceholder from '../containers/HotelListPlaceholder';

import HotelCard from '../../../../stories/components/hotels/SRP/HotelCard/HotelCard';
import NoResultsFound from '../../../../stories/components/hotels/SRP/NoResultsFound/NoResultsFound';
import HotelListLoader from './../../../../stories/components/hotels/Loadingpage/SrpCard/SrpCardAllComponent/SrpCardAllComponent';

// move to types srp

const HotelList = ({fetchMoreFn, updateShareHotelList, shareHotelsList, shareDisabled}) => {
  const dispatch = useDispatch();
  const srp = useSelector(srpSelector);
  const roomString = useSelector(roomStringSelectorFn);
  const country = useSelector(countrySelectorFn);

  const [onSearch] = useNavigateForSearchWidget();

  const {hasData, isLoading, srpData, srpConfig} = srp as ISrpStoreState;
  const {data: hotelListFromState, city_meta_info: cityMetaInfo, next, error} = srpData;
  const {overriderankvhids, metaPartner} = srpConfig;

  if (hasData === null || isLoading) {
    return <HotelListLoader />;
  }

  if (
    (next && next !== 'END' && !hasData) ||
    !cityMetaInfo ||
    !hotelListFromState ||
    hotelListFromState.length === 0
  ) {
    return <NoResultsFound />;
  }

  let bannerCount = smartEngageBannerCount;
  const hotelList = hotelListFromState.reduce((acc, item, index) => {
    const isInternational = country !== countryTextMap.india.key;
    if (index !== 0 && bannerCount > 0) {
      if (!isInternational && (index === 1 || index === 4)) {
        bannerCount--;
        index == 1 ? acc.push({type: 'SmartEngageBanner', selector:1 }) : acc.push({type: 'SmartEngageBanner', selector:2 });
      }
      // IH has different slotting for corona related advisory display
      if (isInternational && Number.isInteger((index / 3 - 1) / 2)) {
        bannerCount--;
        acc.push({type: 'SmartEngageBanner'});
      }
    }
    acc.push(item);
    return acc;
  }, []);

  // ! following function can be memoized for perf optimization
  const getElementHeight = data => {
    return data.map(item => {
      if (item.type === 'SmartEngageBanner') return 130;
      return 250;
    });
  };

  let lockAnimationInitialised = false;

  return (
    <>
      <Infinite
        containerHeight={1900}
        elementHeight={getElementHeight(hotelList)}
        infiniteLoadBeginEdgeOffset={600}
        handleScroll={() => {}} // was required for displaying google ads in pre-allocated slots
        useWindowAsScrollContainer={window ? true : false} // should be set to false for server-side
      >
        {hotelList.map((item: IHotelData & {type: IHotelDataType, selector:number}, index) => {
          const isSearchedHotel = overriderankvhids && overriderankvhids === item.hc && index === 0;
          const isMetaViewedHotel = metaPartner && isSearchedHotel;
          let showLockAnimation = false;
          if (!lockAnimationInitialised && item.dspr) {
            showLockAnimation = true;
            lockAnimationInitialised = true;
          }

          return (
            <React.Fragment key={'hotelItem' + index + item.hn}>
              <HotelListPlaceholder
                shouldFetchMore={hotelList.length - srpIndexForFetchMore === index && next !== 'END'}
                fetchMoreFn={fetchMoreFn}
                showLastItemLoader={hotelList.length - 1 === index && next !== 'END'}
                data={item}
                error={error}
                key={item.hc}
              >
                {(!item.type && (
                  <HotelCard
                    data={item}
                    cityMetaInfo={cityMetaInfo}
                    roomString={roomString}
                    srpConfig={srpConfig}
                    navigateToDetailsPage={filterData => {
                      onSearch(true, item, filterData);
                    }}
                    country={country}
                    isMetaViewedHotel={isMetaViewedHotel}
                    isSearchedHotel={isSearchedHotel}
                    disabledShare={shareDisabled}
                    updateShareHotelList={updateShareHotelList}
                    isShared={shareHotelsList && shareHotelsList[item.hc] ? true : false}
                  />
                )) ||
                  null}
              </HotelListPlaceholder>
            </React.Fragment>
          );
        })}
      </Infinite>
    </>
  );
};

export default HotelList;
